<template>
  <div>
    <homeHead></homeHead>
    <homeNav></homeNav>
    <div class="pre-box" v-if="preview==1" >
        <p>当前文章仅用于预览！</p>
    </div>
    <breadcrumb :positionData="positionData"></breadcrumb>
    
    <div class="overView-box">
      <projectMenu :positionData="positionData"></projectMenu>
      <rightContent :detailData="detailData"></rightContent>
    </div>
    <homeFooter></homeFooter>
  </div>
</template>
<script>
// 机构概况
import homeHead from "@/components/Public/head.vue";
import homeNav from "@/components/Public/nav.vue";
import breadcrumb from "@/components/Public/breadcrumb.vue";
import projectMenu from "@/components/Public/projectMenu.vue";
import rightContent from "./rightContent.vue";
import homeFooter from "@/components/Public/footer.vue";
export default {
  components: {
    homeHead,
    homeNav,
    breadcrumb,
    projectMenu,
    rightContent,
    homeFooter
  },
  metaInfo() {
    return {
      title: this.$store.state.webInfo.title + "-" + this.title,
      meta: [
        {
          name:  this.detailData&&this.detailData.title?this.detailData.title:this.$store.state.webInfo.key_words,
          content:  this.detailData&&this.detailData.description?this.detailData.description:this.$store.state.webInfo.describe
        }
      ],
      link: [
        {
          rel: "asstes",
          href: this.$url.webUrl
        }
      ]
    };
  },
  data() {
    return {
      title: "",
      cate_id: "",
      id: null, //一级导航
      second_navId: null, //二级导航
      positionData: [], //当前位置
      detailData: {}, //详情内容
      detailId: "",
      preview:'',
    };
  },
  created() {
    this.id = Number(this.$route.query.id);
    this.second_navId = Number(this.$route.query.second_navId);
    this.preview = this.$route.query.preview;

    //详情接口需要当前导航的下面绑定的分类 的数据
    let id = this.second_navId ? this.second_navId : this.id;
    this.getCateValue(id);

    this.$db.get(this.$url.channel.childList + "?id=" + this.id).then(res => {
      this.positionData = res.data;
      this.positionData.forEach(element => {
        if (element.pid == 0) {
          this.title = element.title;
        }
      });
    }).catch(err => {
            console.log(err);
          });
  },

  methods: {
    getPosition() {
      this.$db.get(this.$url.channel.childList + "?id=" + this.id).then(res => {
        this.positionData = res.data;
        this.positionData.forEach(element => {
          if (element.pid == 0) {
            this.title = element.title;
          }
        });
      }).catch(err => {
            console.log(err);
          });
    },
    getDetailData() {
      //获取新闻详情 数据 4 测试数据
      this.$db.get(this.$url.document.url + "/" + this.detailId).then(res => {
        this.detailData = res.data;
      }).catch(err => {
            console.log(err);
          });
    },
    getCateValue(channelId) {
      let that = this;
      that.$db.get(this.$url.channel.url + "/" + channelId).then(res => {
        this.detailId = res.data.value;
        this.getDetailData();
      }).catch(err => {
            console.log(err);
          });
    }
  },
  watch: {
    "$route.query.id": function(value) {
      if (value) {
        this.id = value;
        this.getCateValue(this.id);
        this.getPosition();
      }

      // this.getDetailData()
    },
    "$route.query.second_navId": function(value) {
      if (value) {
        this.second_navId = value;
        this.getCateValue(this.second_navId);
      } else if (typeof value == "undefined") {
        this.getCateValue(this.id);
      }

      // this.getDetailData()
    }
  }
};
</script>
<style lang="less" scoped>
.overView-box{
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
}
.pre-box{
    height: 50px;
    margin: 0 auto;
    width: 1200px;
    background-color: bisque;
    >p{
        text-indent:15px;
        color: #ab0f13;
        line-height: 50px;
        font-size: r(24);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/overView/index.vue